module.exports = __webpack_public_path__ + "static/img/tool.7dad5c47.svg";